export default {
  created () {
    this.singleActions = [
      {
        label: this.$t('scope.text_18'),
        permission: 'bill_ratesets_delete',
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: this.$t('scope.text_18'),
            name: this.$t('bill.text_38'),
            onManager: this.onManager,
          })
        },
        hidden: (obj) => obj.id === 'default',
      },
    ]
  },
}
